import type { CalendarDto, CalendarEventDto } from '../../../api/calendar';
import { tCalendar } from '../../../lib/calendar-i18n';

/**
 * 「이 일정이 어느 캘린더 것인가」를 사람이 읽는 한 줄로 — 일간 표의 «캘린더» 열.
 *
 * ⚠ 옛 가지에서는 `eventTooltip.tsx`(119줄) 안에 있었다. 그 파일 전체는 «툴팁»인데,
 *   일간 표는 툴팁을 **안 띄운다**(2026-09-09 사용자 지시 — 제목·설명·참석자가 이미 표에 다 보인다).
 *   그래서 툴팁을 통째로 가져오지 않고 **이 함수 하나만** 옮겼다.
 *
 * ⚠ 옛 판은 `cal.orgTeamId` · `cal.orgTeamName`(조직 팀 캘린더) 갈래도 봤는데 그 두 칸이
 *   지금 `CalendarDto` 에 **없다**. 그 갈래가 생기면 여기 한 줄을 더하면 된다.
 */
export function calendarLabelOf(event: CalendarEventDto, calendars: ReadonlyArray<CalendarDto>): string {
  /*
   * 캘린더를 안 고르고 만든 일정(calendarId 없음)은 「기본 캘린더」다 (2026-10-14 사용자 지적).
   * ⚠ 고르개(`EventCreateModal`)·사이드바 통(NO_CALENDAR)과 «같은 이름»을 쓴다 — 거기서 「기본 캘린더」로
   *   만든 일정이 여기서 「개인 캘린더」로 보여 둘이 안 이어졌다.
   */
  if (!event.calendarId) return tCalendar('calendar.create.calendar_default');
  const cal = calendars.find((c) => c.id === event.calendarId);
  if (cal?.teamId) return cal.teamName ?? tCalendar('calendar.sidebar.team_group');
  return tCalendar('calendar.sidebar.personal_group');
}
